export default __webpack_public_path__ + "static/media/home-hero-bg.e4082c7e.jpg";